
const SearchResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {};
	"searchKey": "9b013ee1-c117-4219-9074-82e7ff022322",
	"pricedItineraries": [
		{
			"isPassportMandatory": false,
			"isPassportIssueDateMandatory": false,
			"directionInd": 0,
			"refundMethod": 0,
			"validatingAirlineCode": "IV",
			"gdsRefrenceID": "d16377eb-ec71-4b30-b393-a2f5b62c50c3",
			"airItineraryPricingInfo": {
				"fareType": 0,
				"itinTotalFare": {
					"baseFare": 9700000,
					"totalFare": 9700000,
					"totalTax": 0,
					"currency": "IRR"
				},
				"ptcFareBreakdown": [
					{
						"passengerFare": {
							"baseFare": 9300000,
							"totalFare": 9700000,
							"taxes": [
								{
									"name": null,
									"amount": 0,
									"currency": "IRR"
								}
							],
							"currency": "IRR"
						},
						"passengerTypeQuantity": {
							"passengerType": 1,
							"quantity": 1
						}
					},
					{
						"passengerFare": {
							"baseFare": 9300000,
							"totalFare": 9300000,
							"taxes": [
								{
									"name": null,
									"amount": 0,
									"currency": "IRR"
								}
							],
							"currency": "IRR"
						},
						"passengerTypeQuantity": {
							"passengerType": 2,
							"quantity": 0
						}
					},
					{
						"passengerFare": {
							"baseFare": 1500000,
							"totalFare": 1500000,
							"taxes": [
								{
									"name": null,
									"amount": 0,
									"currency": "IRR"
								}
							],
							"currency": "IRR"
						},
						"passengerTypeQuantity": {
							"passengerType": 3,
							"quantity": 0
						}
					}
				],
				"fareInfoes": []
			},
			"originDestinationOptions": [
				{
					"journeyDurationPerMinute": 0,
					"connectionTimePerMinute": 0,
					"flightSegments": [
						{
							"departureDateTime": "2023-01-29T08:35:00",
							"arrivalDateTime": "2023-01-29T09:50:00",
							"stopQuantity": 0,
							"flightNumber": "IV024",
							"resBookDesigCode": "Y",
							"journeyDuration": "1:15",
							"journeyDurationPerMinute": 75,
							"connectionTimePerMinute": 0,
							"departureAirportLocationCode": "THR",
							"arrivalAirportLocationCode": "MHD",
							"marketingAirlineCode": "IV",
							"cabinClassCode": "Y",
							"cabinClassCodeName": "Economy",
							"operatingAirline": {
								"code": "IV",
								"flightNumber": "IV024",
								"equipment": "Boeing M80"
							},
							"seatsRemaining": "7",
							"isCharter": true,
							"isReturn": false,
							"baggages": [
								"20"
							],
							"policyRules": [],
							"technicalStops": []
						}
					]
				}
			]
		},
		{
			"isPassportMandatory": false,
			"isPassportIssueDateMandatory": false,
			"directionInd": 0,
			"refundMethod": 0,
			"validatingAirlineCode": "IV",
			"gdsRefrenceID": "cd92e134-2f8e-4bd2-ba75-a3c993466385",
			"airItineraryPricingInfo": {
				"fareType": 0,
				"itinTotalFare": {
					"baseFare": 10591000,
					"totalFare": 10591000,
					"totalTax": 0,
					"currency": "IRR"
				},
				"ptcFareBreakdown": [
					{
						"passengerFare": {
							"baseFare": 10191000,
							"totalFare": 10591000,
							"taxes": [
								{
									"name": null,
									"amount": 0,
									"currency": "IRR"
								}
							],
							"currency": "IRR"
						},
						"passengerTypeQuantity": {
							"passengerType": 1,
							"quantity": 1
						}
					},
					{
						"passengerFare": {
							"baseFare": 10191000,
							"totalFare": 10191000,
							"taxes": [
								{
									"name": null,
									"amount": 0,
									"currency": "IRR"
								}
							],
							"currency": "IRR"
						},
						"passengerTypeQuantity": {
							"passengerType": 2,
							"quantity": 0
						}
					},
					{
						"passengerFare": {
							"baseFare": 2650000,
							"totalFare": 2650000,
							"taxes": [
								{
									"name": null,
									"amount": 0,
									"currency": "IRR"
								}
							],
							"currency": "IRR"
						},
						"passengerTypeQuantity": {
							"passengerType": 3,
							"quantity": 0
						}
					}
				],
				"fareInfoes": []
			},
			"originDestinationOptions": [
				{
					"journeyDurationPerMinute": 0,
					"connectionTimePerMinute": 0,
					"flightSegments": [
						{
							"departureDateTime": "2023-01-29T16:15:00",
							"arrivalDateTime": "2023-01-29T17:45:00",
							"stopQuantity": 0,
							"flightNumber": "026",
							"resBookDesigCode": "Y",
							"journeyDuration": "1:30",
							"journeyDurationPerMinute": 90,
							"connectionTimePerMinute": 0,
							"departureAirportLocationCode": "THR",
							"arrivalAirportLocationCode": "MHD",
							"marketingAirlineCode": "IV",
							"cabinClassCode": "Y",
							"cabinClassCodeName": "Economy",
							"operatingAirline": {
								"code": "IV",
								"flightNumber": "026",
								"equipment": "Boeing M80"
							},
							"seatsRemaining": "4",
							"isCharter": true,
							"isReturn": false,
							"baggages": [
								"20"
							],
							"policyRules": [],
							"technicalStops": []
						}
					]
				}
			]
		},
			
	]
};
 

  export default SearchResponse;
  